export const BOTTOM_RIGHT = "BOTTOM_RIGHT";
export const BOTTOM_LEFT = "BOTTOM_LEFT";
export const TOP_RIGHT = "TOP_RIGHT";
export const TOP_LEFT = "TOP_LEFT";
export const LEFT_POSITIONS = [BOTTOM_LEFT, TOP_LEFT];
export const RIGHT_POSITIONS = [BOTTOM_RIGHT, TOP_RIGHT];
export const BOTTOM_POSITIONS = [BOTTOM_LEFT, BOTTOM_RIGHT];
export const TOP_POSITIONS = [TOP_LEFT, TOP_RIGHT];

export type PositionType =
    | typeof BOTTOM_LEFT
    | typeof BOTTOM_RIGHT
    | typeof TOP_LEFT
    | typeof TOP_RIGHT;
